import { render, staticRenderFns } from "./WeekReviewForm.vue?vue&type=template&id=00123f2f&"
import script from "./WeekReviewForm.vue?vue&type=script&lang=js&"
export * from "./WeekReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./WeekReviewForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports